import { ParamConfig } from "../../../utils/params/ParamsConfig";
import { SetUtils } from "../../../../../core/SetUtils";
import { Poly } from "../../../../Poly";
import { ArrayUtils } from "../../../../../core/ArrayUtils";
export function RootLoadProgressParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.nodesMask = ParamConfig.STRING("*/image* */envMap*", {
        cook: false,
        separatorBefore: true
      });
      this.printNodes = ParamConfig.BUTTON(null, {
        cook: false,
        callback: (node) => {
          RootLoadProgressController.PARAM_CALLBACK_printResolve(node);
        }
      });
    }
  };
}
export class RootLoadProgressController {
  constructor(node) {
    this.node = node;
  }
  static async PARAM_CALLBACK_printResolve(node) {
    const nodes = await node.loadProgress.resolvedNodes();
    console.log(nodes);
    const nodePaths = nodes.map((node2) => node2.path()).sort();
    console.log(nodePaths);
  }
  async resolvedNodes() {
    const param = this.node.p.nodesMask;
    if (param.isDirty()) {
      await param.compute();
    }
    const mask = param.value;
    const scene = this.node.scene();
    const nodes = scene.nodesController.nodesFromMask(mask || "");
    return ArrayUtils.uniq(nodes.concat(await this._loadDisplayNodes()));
  }
  async _loadDisplayNodes() {
    const scene = this.node.scene();
    const cameraNodeTypes = Poly.camerasRegister.registeredNodeTypes();
    const cameraNodes = cameraNodeTypes.map((type) => scene.nodesByType(type)).flat();
    const objNodesWithDisplayNodeController = scene.root().children().filter((node) => node.displayNodeController != null).filter((node) => {
      var _a, _b;
      return (_b = (_a = node.flags) == null ? void 0 : _a.display) == null ? void 0 : _b.active();
    });
    const displayNodes = ArrayUtils.compact(objNodesWithDisplayNodeController.map((node) => node.displayNodeController.displayNode()));
    const nodes = cameraNodes.concat(displayNodes);
    const cameraCreatorNode = await this.cameraCreatorNode();
    if (cameraCreatorNode) {
      nodes.push(cameraCreatorNode);
    }
    return ArrayUtils.uniq(nodes);
  }
  cameraCreatorNode() {
    return this.node.mainCameraController.cameraCreatorNode();
  }
  async watchNodesProgress(callback) {
    const nodes = await this.resolvedNodes();
    const nodesCount = nodes.length;
    if (nodesCount == 0) {
      callback(1, { scene: this.node.scene(), triggerNode: void 0, cookedNodes: [], remainingNodes: [] });
    }
    const remainingNodes = SetUtils.fromArray(nodes);
    const cookedNodes = /* @__PURE__ */ new Set();
    const callbackName = "RootLoadProgressController";
    for (let node of nodes) {
      node.compute();
      node.cookController.registerOnCookEnd(callbackName, () => {
        if (!cookedNodes.has(node)) {
          cookedNodes.add(node);
          remainingNodes.delete(node);
          const nodesCookProgress = cookedNodes.size / nodesCount;
          callback(nodesCookProgress, {
            scene: this.node.scene(),
            triggerNode: node,
            cookedNodes: SetUtils.toArray(cookedNodes),
            remainingNodes: SetUtils.toArray(remainingNodes)
          });
          node.cookController.deregisterOnCookEnd(callbackName);
        }
      });
    }
  }
}
